<template>
  <el-main class="body">
    <div class="body-top" style="margin-top:10px;display: flex;flex-direction: row;flex-wrap: wrap;justify-content: space-between">
      <div>
        <el-form
            ref="form"
            :model="params"
            class="form"
            label-width="80px">
          <div class="vm-separate">
            <el-form-item label="开始时间">
              <el-date-picker
                  v-model="params.beginSubmitTime"
                  value-format="yyyy-MM-dd HH:00:00"
                  type="date"
                  style="width:180px"
                  placeholder="选择日期"/>
            </el-form-item>
            <el-form-item label="结束时间">
              <el-date-picker
                  v-model="params.endSubmitTime"
                  value-format="yyyy-MM-dd 23:59:59"
                  type="date"
                  style="width:180px"
                  placeholder="选择日期"/>
            </el-form-item>
            <el-form-item label="查询方式" prop="inquiryMode">
              <el-select v-model="params.inquiryMode" placeholder="请选择" style="width: 80px;">
                <el-option label="日" :value="1"/>
                <el-option label="周" :value="2"/>
                <el-option label="月" :value="3"/>
                <el-option label="年" :value="4"/>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <div>
        <el-button @click="params=$options.data().params">清空</el-button>
        <el-button :loading="submitLoading" type="primary" @click="getData">查询</el-button>
        <el-button :loading="exportLoading" type="success" @click="buyListDownLoadFile">导出</el-button>
      </div>
      <div style="color: red;font-size: 12px;font-weight: bold;padding-left: 20px">
        <p>注意：统计不包含以下客户【奥的斯机电电梯有限公司】、【奥的斯机电电梯（重庆）有限公司】、【蒂升电梯（上海）有限公司】、【A蒂升电梯（中国）有限公司】</p>
      </div>
    </div>
    <div style="margin-top: 20px;">
      <div class="div-table" style="float: left">
        <table class="table-left">
          <tr>
            <td>统计周期</td>
          </tr>
          <tr>
            <td>导入订单数量</td>
          </tr>
          <tr>
            <td>总订单数量</td>
          </tr>
          <tr>
            <td style="height: 100px;">占比</td>
          </tr>
        </table>
      </div>
      <div class="div-table2" style="float: right;overflow-x: scroll">
        <table class="table-right">
          <tr>
            <td v-for="(item,index) in model" :key="index">
              <div style="padding: 0px 5px;width: 100px">{{item.queryCycle}}</div>
            </td>
          </tr>
          <tr>
            <td v-for="(item,index) in model" :key="index">
              <span style="color: #2D8CF0;cursor: pointer">{{item.importQty}}</span>
            </td>
          </tr>
          <tr>
            <td v-for="(item,index) in model" :key="index">
              <span style="color: #2D8CF0;cursor: pointer">{{item.totalQty}}</span>
            </td>
          </tr>
          <tr>
            <td v-for="(item,index) in model" :key="index" style="height: 100px">
              <div style="width: 100%;height: 80px;position: relative">
                <div class="shipmentRate" :style="{height:item.rate}"/>
              </div>
              <div style="height:20px;width: 100%;border-top: 1px solid #ddd;line-height: 20px">
                <span>
                  {{item.rate}}
                </span>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </el-main>
</template>
<script>

  export default {
    name: "ImportSalesOrderCountList",
    components: {},
    data() {
      return {
        selection: [],
        submitLoading:false,
        exportLoading:false,
        params: {
          beginSubmitTime: "",
          endSubmitTime: "",
          inquiryMode: 1,
        },
        model:[],
        maxPunctuality: "",
      };
    },
    methods: {

      //下载清单
      buyListDownLoadFile() {
        this.downloadLoading = true;
        this.$http
          .exportFile("basic", "sd/so/exportImportSalesOrder", this.params)
          .then((resp) => {
            let blob = new Blob([resp.data]);
            let fileName = decodeURI(resp.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.downloadLoading = false;
          })
          .catch(() => {
            this.downloadLoading = false;
          });
      },

      getData() {
        if (!this.params.beginSubmitTime || !this.params.endSubmitTime) {
          this.$message.error("请设置查询参数");
          return;
        }
        this.submitLoading = true;
        this.$http
          .get("basic", "sd/so/getImportSalesOrderResult", this.params)
          .then((res) => {
            console.log(res);
            this.model = res;
            this.maxPunctuality = Math.max.apply(Math, this.model.map(function(item) {
              return item.rate;
            }));
            console.log(this.maxPunctuality);
            this.submitLoading = false;
            this.$message.success("获取成功");
          })
          .catch(() => {
            this.submitLoading = false;
            this.$message.error("获取失败");
          });
      },


    },
  };
</script>
<style lang="scss" scoped>
.body {
  height: 88vh;

  .table-left {
    width: 100%;
    border-top: 1px solid #dddddd;
    border-left: 1px solid #dddddd;

    tr {
      td {
        font-size: 15px;
        text-align: center;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
        height: 35px;
        line-height: 35px;
        font-weight: bold;
      }
    }
  }

  .table-right {
    border-top: 1px solid #dddddd;
    border-left: 0;

    tr {
      td {
        font-size: 15px;
        text-align: center;
        border-right: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
        height: 35px;
        line-height: 35px;
        width: 110px;
      }
    }
  }

  .shipmentRate {
    width: 60%;
    /*margin: 0 auto 5px auto;*/
    background: #2D8CF0;
    position: absolute;
    bottom: 0;
    left: 20%;
  }
}

.el-main {
  padding: 0 !important;
}

@media (min-width: 1200px) and (max-width: 1692px) {
  .div-table {
    width: 15%;
  }
  .div-table2 {
    width: 85%;
  }
}

@media (min-width: 1693px) {
  .div-table {
    width: 10%;
  }
  .div-table2 {
    width: 90%;
  }
}
</style>
